module.exports = __webpack_public_path__ + "img/contacttop.8b4f41b3.jpg";